import { ApiResponseData } from "types/common";

export const isData = (data: ApiResponseData) => {
  return data?.status === "success" ? data?.data : [];
};
